export class FormatUtils {

    static asCurrency(symbol, number, ) {
        let isNegative = false;
        if (number < 0) {
            number = Math.abs(number);
            isNegative = true;
        }
        return ((isNegative) ? "-" + symbol : symbol) + " " + Intl.NumberFormat('en-ZA').format(number);
    }

    static withDecimals(number, decimal) {
        return number.toFixed(decimal);
    }

    static asPercentage(number, decimal = 0) {
        return number.toFixed(decimal) + "%";
    }

    static formatLabels(labels) {
        let newLabels = [];

        for (var i = 0; i < labels.length; i++) {
            if (/\s/.test(labels[i])) {
                //console.log('space detected in "' + labels[i])
                newLabels.push(labels[i].split(" "));
            } else {
                newLabels.push(labels[i]);
            }
        }
        return newLabels;
    }

    static replaceWithSpaces(replace, string) {
        return string.replaceAll(replace, " ") + " ";
    }

    static shortenLabel(label, size) {
        return label.substring(0, size) + "...";
    }
}
